module.exports = __webpack_public_path__ + "media/img/frontend_application/help/bg-help-d7f9cfdc49bb55fc05a6c9b69af34df0.png";